// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Filter
 */
export interface Filter {
  /**
   *
   */
  field: string;
  /**
   *
   */
  values: Array<any>;
}

/**
 * Check if a given object implements the Filter interface.
 */
export function instanceOfFilter(value: object): value is Filter {
  if (!("field" in value) || value["field"] === undefined) return false;
  if (!("values" in value) || value["values"] === undefined) return false;
  return true;
}

export function FilterFromJSON(json: any): Filter {
  return FilterFromJSONTyped(json, false);
}

export function FilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): Filter {
  if (json == null) {
    return json;
  }
  return {
    field: json["field"],
    values: json["values"],
  };
}

export function FilterToJSON(json: any): Filter {
  return FilterToJSONTyped(json, false);
}

export function FilterToJSONTyped(
  value?: Filter | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    field: value["field"],
    values: value["values"],
  };
}
